import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCommercialSearchList } from '../searchThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'commercialSearch';

export const commercialSearchSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCommercialSearchList });
    },
});

export const commercialSearch = commercialSearchSlice.reducer;
